export const formatPhoneNumber = (event) => {
  const element = event.target;
  element.value = element.value
    .replace(/\D/g, "")
    .slice(0, 10)
    .replace(/(\d{1,3})(\d{0,3})(\d{0,4})/, "($1)$2-$3")
    .replace(/[()-]+$/g, "");

  return element.value;
};

// Like formatPhoneNumber, but drops a leading US country code first, so a
// pasted "+1 555-555-0123" formats as "(555)555-0123" instead of being
// truncated to the wrong number "(155)555-5012".
//
// Deliberately a separate export rather than a change to formatPhoneNumber:
// that one is wired to tel inputs across checkout, the customer portal, and
// contact forms, so this stays opt-in for fields that expect pasted numbers.
export const formatPhoneNumberWithCountryCode = (event) => {
  const element = event.target;
  // Only strip the 1 when a full 10-digit number follows it, so a number being
  // typed one digit at a time is left alone until it's unambiguous.
  element.value = element.value.replace(/\D/g, "").replace(/^1(?=\d{10})/, "");

  return formatPhoneNumber(event);
};

export const formatLicensePlate = ({ target }) => {
  target.value = target.value
    // A-z spans the punctuation between the two alphabets ([ \ ] ^ _ `), which let those through
    // and put this out of step with LicensePlateValidator.normalize on the server.
    .replace(/[^0-9A-Za-z]/g, "")
    .toUpperCase()
    .substring(0, 8);
};
